module.exports = __webpack_public_path__ + "img/visit-heart.c875176e.svg";